export default __webpack_public_path__ + "static/media/logo-black.8f3a5b54.svg";